module.exports = __webpack_public_path__ + "img/img1.2bb6106.png";